<template>
  <div class="main-layout unselectable">
    <div class="bs-b" v-if="isDesktop">
      <DesktopHeader
        v-bind:nav-state="navState"
      />

      <slot name="desktop-subheader"></slot>
    </div>
    
    <AppHeader v-bind:header-title="headerTitle"
               v-bind:hide-arrow-back-btn="hideArrowBackBtn"
               v-bind:hide-close-btn="hideCloseBtn"
               v-bind:colored-app-header="coloredAppHeader"
               v-else>
    </AppHeader>

    <div class="page-content" v-bind:class="{ 'pt-25': isDesktop }">
      <slot name="layout-body"></slot>
    </div>

    <slot name="modal-area"></slot>
  </div>
</template>

<script>
  import desktop from '@/mixins/desktop';

  export default {
    name: 'main-layout',

    mixins: [
      desktop,
    ],

    props: {
      headerTitle: {
        type: String,
        default: '',
      },
      hideArrowBackBtn: {
        type: Boolean,
        default: false,
      },
      hideCloseBtn: {
        type: Boolean,
        default: false,
      },
      coloredAppHeader: {
        type: Boolean,
        default: false,
      },
      navState: {
        type: String,
        default: null,
      },
    },
  };
</script>

<style lang="scss">
  .main-layout {
    .page-content {
      padding-top: 57px;
    }
  }
</style>



// WEBPACK FOOTER //
// MainLayout.vue?07deaf93